<script setup>
const { game } = defineProps({
    game: {
        type: Object,
        required: true,
    },
})

function onClickButtonEdit(link) {
    window.location.href = link + '/update'
}
</script>

<template>
<component
    :is="game.can_open ? 'a' : 'div'"
    :href="game.can_open ? game.link : '#'"
    class="match-card m-card text-decoration-none"
>
    <div class="played-team home-team">
        <div class="played-team__content d-flex flex-column h-100">
            <h3 class="played-team__title display40 fw-bold">
                {{ game.is_group ? game.home.title : game.home.club.title }}
            </h3>
            <ul v-if="game.is_group" class="played-team__players mt-auto">
                <li v-for="player in game.home.players" class="played-team__player rounded-circle">
                    <img :src="player.avatar" :alt="player.tag">
                </li>
            </ul>
            <ul v-else class="played-team__players mt-auto">
                <li class="ms-2 display12 text-end">
                    <span class="fw-bold">{{ game.home.tag }}</span><br>
                    <small class="text-muted">{{ game.home.name }}</small>
                </li>
                <li class="played-team__player ms-1 rounded-circle">
                    <img :src="game.home.avatar" :alt="game.home.tag">
                </li>
            </ul>
        </div>
        <div class="played-team__logo-wrap">
            <span class="played-team__logo">
                <img :src="game.is_group ? game.home.avatar : game.home.club.logo"
                        :alt="game.is_group ? game.home.title : game.home.club.title"
                >
            </span>
        </div>
    </div>
    <div class="match-result split">
        <div v-if="game.can_edit && game.id" class="match-result__captains">
            <button @click.prevent="onClickButtonEdit(game.link)" class="match-result__captains-btn" type="button">
                <img src="/images/game_edit.svg" alt="">
            </button>
            <!-- {{-- <button class="match__delete visually-hidden text-danger"></button> --}} -->
        </div>

        <div class="match-result__top">
            <div class="match-result__score display90 fw-bold">
                {{ game.score_string }}
            </div>
            <div class="match-result__info display25 fw-bold">
                <template v-if="game.is_overtime">ОТ</template>
                <template v-else-if="game.is_shootout">Б</template>
                <template v-else-if="game.is_shootout">ТП</template>
            </div>
            <small class="match-result__playoff-stage">
                <template v-if="game.playoff_stage">{{ game.playoff_stage }}</template>
                <template v-else-if="game.division">{{ game.division }}</template>
            </small>
        </div>
        <div class="match-result__comp fw-bold">{{ game.tournament.title }}</div>
        <div class="match-result__dates gray-text">
            <div class="match-result__date display20 fw-bold">
                <template v-if="game.home.score !== null && game.away.score !== null">{{ game.date }}</template>
                <template v-else>{{ game.week_day }}</template>
            </div>
            <div class="match-result__date display20 fw-bold">
                <span v-if="game.home.score !== null && game.away.score !== null">{{ game.time }}</span>
                <span v-else>{{ game.date }}</span>

                <div class="match-result__status">
                    <img v-if="game.home.score !== null && game.away.score !== null" src="/images/game_accepted.svg" alt="">
                    <img v-else src="/images/game_planned_on.svg" alt="">
                </div>
            </div>
            <div v-if="game.can_edit && !game.id" class="match-result__date game-planned-on">
                <input type="text" class="form-control me-2" name="planned_on" readonly>
                <button class="btn btn-primary" type="button">Запланировать</button>
            </div>
        </div>
    </div>
    <div class="played-team away-team played-team--reverse">
        <div class="played-team__logo-wrap">
            <span class="played-team__logo">
                <img
                    :src="game.is_group ? game.away.avatar : game.away.club.logo"
                    :alt="game.is_group ? game.away.title : game.away.club.title"
                >
            </span>
        </div>
        <div class="played-team__content align-items-start d-flex flex-column h-100">
            <h3 class="played-team__title display40 fw-bold">
                {{ game.is_group ? game.away.title : game.away.club.title }}
            </h3>
            <ul v-if="game.is_group" class="played-team__players mt-auto">
                <li v-for="player in game.away.players" class="played-team__player rounded-circle">
                    <img :src="player.avatar" :alt="player.tag">
                </li>
            </ul>
            <ul v-else class="played-team__players mt-auto">
                <li class="played-team__player rounded-circle">
                    <img :src="game.away.avatar" :alt="game.away.tag">
                </li>
                <li class="ms-2 display12">
                    <span class="fw-bold">{{ game.away.tag }}</span><br>
                    <small class="text-muted">{{ game.away.name }}</small>
                </li>
            </ul>
        </div>
    </div>
</component>
</template>
